export default function CardHpTutorIntro({title, image, description}) {
    return (
        <div className="flex gap-075 flex-column keduall-card justify-content-start cards-hp-intro w-full h-full">
            <div className="flex justify-content-center align-items-center h-half">
                <img src={image} className="flex w-fit h-fit justify-content-end" alt=""></img>
            </div>
            <div className="flex flex-column justify-content-start gap-075 px-3 pb-3 h-half">
                <div className="flex keduall-typography heading-h5-semibold-600 mt-3">{title}</div>
                <div className="keduall-typography text-14-normal-400">{description}</div>
            </div>
        </div>
    )
}